import React, { useEffect, useCallback, useRef } from "react";
import { HiddenForm } from "./styles";
import { useDispatch } from "react-redux";
import { clearExportedChartPayload } from "../../../../../stores/actions/chartExporting";
import { createBase64Signature } from "../encoder/signature";

export const PNGExportationForm = ({ base64Content }) => {
  const submitButtonRef = useRef(null);
  const dispatch = useDispatch();

  // Aciona de forma automática o download da imagem exportada
  useEffect(() => {
    if (base64Content && submitButtonRef.current) {
      // Efetua o download do gráfico exportado
      submitButtonRef.current.click();
      // Limpa os dados de exportação da ultima ação
      clearExportedChartPayload(dispatch);
    }
  }, [base64Content, submitButtonRef, useDispatch]);

  const getAnalyzeChartExporterPayload = useCallback(() => {
    const signature = createBase64Signature(base64Content);
    const url = `${process.env.REACT_APP_EXPORTER_APP_URL}/${signature}`; // `${process.env.REACT_APP_EXPORTER_APP_URL}${signature}`;

    const payload = {
      url,
      signature,
    };

    return payload;
  }, [base64Content]);

  const { url: chartExporterUrl, signature } = getAnalyzeChartExporterPayload();

  return (
    <HiddenForm method="POST" target="_blank" action={chartExporterUrl}>
      <input type="hidden" name="content" value={base64Content}></input>
      <input type="hidden" name="signature" value={signature}></input>
      <button ref={submitButtonRef} type="submit"></button>
    </HiddenForm>
  );
};
